// Plain leaf constant with NO imports. Kept in its own module so that
// module-scope consumers — e.g. the module-level `optionItemSx` in
// modules/form/components/Input.tsx and the styled() defaults in Select.tsx —
// can read it without forcing the whole `components/inputs` (and transitively
// `components`) barrel to be initialized first. Reading a barrel-sourced binding
// at module scope produced a bundled-build TDZ ("Cannot access 'X' before
// initialization") in the Storybook/production build; a zero-import leaf is
// guaranteed to be initialized before anything that imports it.
export const menuItemColor = '#4C4D4D';
